// extracted by mini-css-extract-plugin
export default {"root":"EtwLA9kN2QdxxA3QU1Sw","footer":"_YQoXyKLjmdaErOh0Bwc"};